export default __webpack_public_path__ + "static/media/2Pblue_4P.4b100a5c.png";